module.exports = __webpack_public_path__ + "img/horizontal_3_7_pp123_3.578ac0d1.png";